module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container",
    staticStyle: {
      "height": "100%"
    }
  }, [(!this.$parent.isDesktop) ? _c('div', {
    staticClass: "pause_video",
    on: {
      "click": _vm.pasuedVideo
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "video-player",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    on: {
      "click": _vm.loadVideo
    }
  }, [(_vm.videoState === 'paused') ? _c('button', {
    staticClass: "video-player__controls"
  }, [_c('img', {
    attrs: {
      "data-src": "https://prod-img.thesouledstore.com/static/media/play.png",
      "alt": "Media Play"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.videoState === 'loading') ? _c('button', {
    staticClass: "video-player__controls"
  }, [_c('img', {
    attrs: {
      "data-src": "https://prod-img.thesouledstore.com/static/media/play.png",
      "alt": "Media Play"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.muted && _vm.videoState === 'play') ? _c('button', {
    staticClass: "video-player__controls muted",
    on: {
      "click": function($event) {
        _vm.muteVideo($event, false)
      }
    }
  }, [(_vm.playNewDesign) ? _c('img', {
    attrs: {
      "src": 'https://prod-img.thesouledstore.com/static/mute-icon.png',
      "alt": "Media Mute"
    }
  }) : _c('img', {
    attrs: {
      "data-src": "https://prod-img.thesouledstore.com/static/media/mute.png",
      "alt": "Media Mute"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.muted && _vm.videoState === 'play') ? _c('button', {
    staticClass: "video-player__controls sound",
    on: {
      "click": function($event) {
        _vm.muteVideo($event, true)
      }
    }
  }, [(_vm.playNewDesign) ? _c('img', {
    attrs: {
      "src": 'https://prod-img.thesouledstore.com/static/sound-icon.png',
      "alt": "Media Sound"
    }
  }) : _c('img', {
    attrs: {
      "data-src": "https://prod-img.thesouledstore.com/static/media/sound.png",
      "alt": "Media Sound"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.videoPlayback) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "z-index": "1"
    },
    on: {
      "click": _vm.loadVideo
    }
  }) : _vm._e(), _vm._v(" "), _c('video', {
    ref: "video",
    staticClass: "video-js",
    staticStyle: {
      "height": "100%",
      "width": "100%",
      "object-fit": "cover"
    },
    attrs: {
      "crossorigin": "",
      "poster": _vm.posterImg,
      "muted": "",
      "autoplay": "",
      "loop": "",
      "playsinline": ""
    },
    on: {
      "playing": _vm.checkVideoStatus
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.src,
      "type": "video/mp4"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30d10ecc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/VideoPlayer.vue
// module id = 999
// module chunks = 113